import classNames from 'classnames';

type Props = React.HTMLAttributes<HTMLElement> & {};

const Spinner = (props: Props) => {
    return <div {...props} className={classNames('spinner', props.className)}></div>;
};

export default Spinner;
